import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { LikeButton as UiKitLikeButton } from '@bwoty-web/ui-kit';
import './likeButton.scss';

const logToDataLayer = (checked, wvId, hotelContent) => {
  const { destCd } = hotelContent?.meta || {};

  const data = {
    event: checked ? 'add_favorite_hotel' : 'remove_favorite_hotel',
    'gtm.uniqueEventId': checked ? 167 : 414,
    hotelWVId: wvId,
    travelDestinationCode: destCd,
    travelProductBrand: hotelContent?.productInfo?.productName,
  };

  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(data);
  }
};

const LikeButton = ({ idunUrl = '', wvId, siteId, hotelContent = {} }) => {
  const [isFavorite, setIsFavorite] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${idunUrl}/api/favorites?siteId=${siteId}`, {
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((favorites) => setIsFavorite(favorites.includes(wvId)))
      .finally(() => setIsLoading(false));
  }, [idunUrl, siteId, wvId]);

  const toggleFavorite = (e) => {
    const { checked } = e.target;
    const action = checked ? 'add' : 'delete';

    logToDataLayer(checked, wvId, hotelContent);

    setIsFavorite(checked);
    fetch(`${idunUrl}/api/favorites/${action}/${wvId}?siteId=${siteId}`, {
      credentials: 'include',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to ${action} favorite`);
        }
      })
      .catch((error) => {
        setIsFavorite(!checked);
      });
  };

  if (isLoading) {
    return null;
  }

  return (
    <UiKitLikeButton
      className="gw-hotel-info__like-button"
      checked={isFavorite}
      onChange={toggleFavorite}
    />
  );
};

LikeButton.propTypes = {
  idunUrl: PropTypes.string,
  wvId: PropTypes.string.isRequired,
  siteId: PropTypes.number.isRequired,
  hotelContent: PropTypes.shape({
    destCd: PropTypes.string,
    productInfo: PropTypes.shape({ productName: PropTypes.string }),
  }),
};

export default LikeButton;
